<div class="dialog-letter">

  <div class="card-div">
    <mat-dialog-content class="mat-typography">
      <h1 mat-dialog-title><app-brand-mark [size]="56"></app-brand-mark> {{ 'auth.forgotTitle' | t }}</h1>

      <div class="card">
        <div class="card-body">
          @if (success) {
            <div class="alert alert-success mb-0">
              {{ 'auth.forgotSuccess' | t }}
            </div>
          }
          @if (!success) {
            <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()">
              <p>{{ 'auth.forgotIntro' | t }}</p>
              <div class="form-group">
                <label style="display: flex;" for="email">{{ 'common.email' | t }}</label>
                <input type="email" formControlName="email" class="form-control"
                  [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                @if (submitted && f.email.errors) {
                  <div class="invalid-feedback">
                    @if (f.email.errors.required) {
                      <div>{{ 'common.emailRequired' | t }}</div>
                    }
                    @if (f.email.errors.email) {
                      <div>{{ 'common.emailInvalid' | t }}</div>
                    }
                  </div>
                }
              </div>
              <button [disabled]="loading" class="btn btn-primary" cdkFocusInitial>
                @if (loading) {
                  <span class="spinner-border spinner-border-sm mr-1"></span>
                }
                {{ 'auth.sendLink' | t }}
              </button>
              @if (error) {
                <div class="alert alert-danger mt-3 mb-0">{{error}}</div>
              }
            </form>
          }
        </div>
      </div>
      <br>
        <button mat-dialog-close mat-stroked-button>{{ 'common.close' | t }}</button>
      </mat-dialog-content>
    </div>
  </div>
